import Axios from "./axios";

const resource = "business-testimonials";

export default {
  get() {
		return Axios.get(`${resource}`);
	}
}